import { render, staticRenderFns } from "./LabelPrinter.vue?vue&type=template&id=4f909dee&scoped=true"
import script from "./LabelPrinter.vue?vue&type=script&lang=js"
export * from "./LabelPrinter.vue?vue&type=script&lang=js"
import style0 from "./LabelPrinter.vue?vue&type=style&index=0&id=4f909dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f909dee",
  null
  
)

export default component.exports